module.exports = __webpack_public_path__ + "static/media/DSC_0332.6995d4be.jpg";